import { computeStars } from "../lib/constants";
import { ElapsedTimer } from "./ElapsedTimer";
import styles from "./SolvedBadge.module.css";

interface SolvedBadgeProps {
  swapsRemaining: number;
  getLiveFocusedMs: () => number;
  solvedAt: number | null;
  onClick: () => void;
}

export function SolvedBadge({ swapsRemaining, getLiveFocusedMs, solvedAt, onClick }: SolvedBadgeProps) {
  const overLimit = swapsRemaining < 0;
  const stars = computeStars(swapsRemaining);
  const starStr = overLimit
    ? "Over limit"
    : "\u2605".repeat(stars) + "\u2606".repeat(6 - stars);

  return (
    <button className={styles.badge} onClick={onClick} title="View results">
      <span className={styles.label}>Solved</span>
      <span className={overLimit ? styles.starsOver : styles.stars}>{starStr}</span>
      <span className={styles.time}>
        <ElapsedTimer getLiveFocusedMs={getLiveFocusedMs} solvedAt={solvedAt} />
      </span>
    </button>
  );
}
